export const UPDATE_CURRENT_USER = 'updateCurrentUser';
export const UPDATE_USER_MANAGER = 'updateUserManager';
